import { render } from "./RightArrow.vue?vue&type=template&id=6de5c7a4"
import script from "./RightArrow.vue?vue&type=script&lang=js"
export * from "./RightArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__